import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendApi, re, emailValidation, phNum } from "../../api/apiService";
import { HiStatusOnline } from "react-icons/hi";
import DatePicker from "react-datepicker";
import BlacklistPopUp from "./BlacklistPopUp.jsx";
import { useLocation } from "react-router-dom";
import { FaWindowClose } from "react-icons/fa";
import moment from 'moment';
import AWS from "aws-sdk";
import pdf_img from "../../images/pdf_image.png"
import {
    FiSearch,
    FiMail,
    FiPhone,
    FiUsers,
    FiCalendar,
    FiMapPin,
} from "react-icons/fi";
import { BsCashStack } from "react-icons/bs";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineCategory } from "react-icons/md";
import { MdPriorityHigh, MdOutlineCurrencyRupee } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { awsConfig } from "../../config.js";
import "react-datepicker/dist/react-datepicker.css";
// import { FaHome } from "react-icons/fa";

function CandidateBlackListInfo() {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);

    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const candidate = location.state.candidate;
    console.log(candidate, "candidate");
    const [menuClick, setMenuClick] = useState(false);
    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };
    const [BlacklistReason, setBlacklistReason] = useState(false);
    const [parentMainArray, setParentMainArray] = useState([]);
    const handleReasonData = (data) => {
        setParentMainArray((prevArray) => [...prevArray, ...data]);
        setBlacklistReason(false);
    };
    useEffect(() => {
        if (parentMainArray.length > 0) {
            console.log("Parent received data on parent page:", parentMainArray);
        }
    }, [parentMainArray]);

    const handleRemoveItem = (index) => {
        const updatedArray = parentMainArray.filter((_, i) => i !== index);
        setParentMainArray(updatedArray);
    };


    //submit api
    const [loading, setLoading] = useState(false);
    const saveNewRequirement = async () => {
        const showToastError = (message) => {
            toast.error(message, { containerId: "F" });
        };

        // Validation checks
        if (!startDate) {
            showToastError("Start Date is required.");
            return;
        }
        if (!endDate) {
            showToastError("End Date is required.");
            return;
        }
        if (!parentMainArray || parentMainArray.length === 0) {
            showToastError("At least one reason for blacklisting is required.");
            return;
        }

        // AWS S3 Configuration
        const bucketParams = {
            Bucket: awsConfigDataState.s3Bucket,
        };
        AWS.config.update({
            accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
            secretAccessKey: process.env.REACT_APP_TAGTREE_S3_SECRET_KEY,
            region: "us-east-1",
        });

        const s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: bucketParams,
        });

        try {
            setLoading(true);

            // File upload function
            const uploadFileToS3 = async (file, folderPath) => {
                if (!file) return null;

                const timestamp = Date.now();
                const formattedTimeStamp = moment(timestamp).format("YYYY-MM-DD_hh-mm-ss");
                const fileExtension = file.type.split("/")[1];
                const modifiedFileName = `${file.name.split(".")[0]}_${formattedTimeStamp}.${fileExtension}`;
                const key = `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${folderPath}/${modifiedFileName}`;

                const uploadParams = {
                    Bucket: awsConfigDataState.s3Bucket,
                    Key: key,
                    Body: file,
                    ACL: "public-read",
                };

                const data = await s3.upload(uploadParams).promise();
                return data.Location;
            };

            // Process the main array and upload files
            const updatedArray = await Promise.all(
                parentMainArray.map(async (item) => {
                    const updatedItem = { ...item };

                    for (let key of ["doc_attach1", "doc_attach2", "doc_attach3", "doc_attach4"]) {
                        if (item[key]) {
                            const location = await uploadFileToS3(item[key], key);
                            updatedItem[key] = location;
                        }
                    }

                    return updatedItem;
                })
            );

            console.log("Updated Array:", updatedArray);

            // Create API payload
            const api = {
                functionName: "blackListCandidateSave",
                candidate_id: candidate.id,
                sec_user_id: localStorage.getItem("userId"),
                created_by: localStorage.getItem("userId"),
                duration_start: moment(startDate).format("YYYY-MM-DD"),
                duration_end: moment(endDate).format("YYYY-MM-DD"),
                site_id: localStorage.getItem("siteId"),
                email_id: candidate.email_id,
                mobile_no: candidate.mobile_no,
                reason: updatedArray,
            };

            console.log("Final API Payload:", api);

            // Uncomment to call the backend API
            backendApi(api).then((response) => {
                if (response.success === "1") {
                    navigate("/dashboard/searchResult");
                    toast.success("Move to Blacklist successfully", {
                        containerId: "F",
                    });
                } else {
                    toast.error("Something went wrong", { containerId: "F" });
                    console.error("Something went wrong", response);
                }
            });
        } catch (error) {
            console.error("Error uploading files:", error);
            toast.error("File upload failed. Please try again.", { containerId: "F" });
        } finally {
            setLoading(false);
        }
    };


    const handleDateChange = (date) => {
        setStartDate(date);
        console.log('Selected Date:', date);
    };
    const handleDateChangeend = (date) => {
        setEndDate(date);
        console.log('Selected Date:', date);
    };

    return (
        <>
            <div className="main-wrapper">
                <div className="top-color"></div>
                <ToastContainer
                    enableMultiContainer
                    containerId={"F"}
                    position="bottom-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
                <div className="content-wrapper">
                    <Header
                        Header=" Employee Background "
                        toggleMenu={toggleMenu}
                        menuClick={menuClick}
                    />
                    <div className="main-container">
                        <div className="xilliRight">
                            <div className="xilliWrap">
                                <div className="card main-card">
                                    <div className="card-body">
                                        {/* <div className="row">
                                            <div className="d-flex justify-content-end mb-3">
                                                <button className="btn-btn btn btn-btn2 btn-sm me-2" onClick={() => navigate('/CreateBlackList')}>
                                                    Blacklist
                                                </button>
                                                <button className="btn-btn btn btn-btn2 btn-sm">
                                                    Review
                                                </button>
                                            </div>
                                        </div> */}

                                        <div className="card-inner">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <h4 className="job-view-header">
                                                        {candidate.full_name}
                                                    </h4>
                                                    <div className="mb-2">
                                                        {/* <span className="label-text">Description :{" "}</span>   */}
                                                        <span className="font-Medium "> Xilligence</span>
                                                    </div>
                                                    <div className="flex-result">
                                                        <div className="flex-sub-div">
                                                            <span className="label-text">
                                                                <FiPhone className="me-1" />
                                                            </span>
                                                            <span className="font-Medium ">
                                                                {candidate.mobile_no}
                                                            </span>
                                                        </div>
                                                        <div className="flex-sub-div">
                                                            <span className="label-text me-2">
                                                                <FiMail className="me-1" />
                                                            </span>
                                                            <span className="font-Medium ">
                                                                {candidate.email_id}
                                                            </span>
                                                        </div>
                                                        <div className="flex-sub-div">
                                                            <span className="label-text me-2">
                                                                <GrUserExpert />
                                                            </span>
                                                            <span className="font-Medium ">
                                                                {" "}
                                                                {candidate.total_experiance
                                                                    ? candidate.total_experiance
                                                                    : 0}{" "}
                                                                year(s)
                                                            </span>
                                                        </div>
                                                        <div className="flex-sub-div">
                                                            <span className="label-text me-2">
                                                                <FiMapPin className="me-1" />
                                                            </span>
                                                            <span className="font-Medium ">
                                                                {candidate.address
                                                                    ? candidate.address
                                                                    : "Not Available"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row border-top pt-3 mt-2">
                                                <div className="col-md-12">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="form-group col-md-4 mb-3 pe-2">
                                                            <label htmlFor="" className="form-label">
                                                                Duration Start:{" "}
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <DatePicker
                                                                className="form-control w-100"
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                minDate={new Date()}
                                                                showMonthDropdown
                                                                placeholderText="Select date"
                                                                selected={startDate}
                                                                onChange={handleDateChange}
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4 mb-3 ps-2">
                                                            <label htmlFor="" className="form-label">
                                                                Duration End:{" "}
                                                                <span className="text-danger">*</span>
                                                            </label>
                                                            <DatePicker
                                                                className="form-control"
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                minDate={new Date()}
                                                                showMonthDropdown
                                                                placeholderText="Select date"
                                                                selected={endDate}
                                                                onChange={(date) => handleDateChangeend(date)}
                                                            />                                                           
                                                        </div>

                                                        <button
                                                            className="btn-btn btn btn-btn2 btn-sm me-2"
                                                            onClick={() => setBlacklistReason(true)}
                                                        >
                                                            Reason
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="d-flex align-items-center my-2 mb-3">
                                                <div className="form-check me-4">
                                                    <label className="font-Medium">
                                                        <input
                                                            type="checkbox"
                                                            id="checkWebsite1"
                                                            className="me-2"
                                                        />
                                                        Publish to Website
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <label className="font-Medium">
                                                        <input
                                                            type="checkbox"
                                                            id="checkWebsite2"
                                                            className="me-2"
                                                        />
                                                        Approve
                                                    </label>
                                                </div>
                                            </div> */}
                                            {parentMainArray.length > 0 ? <div className="table-responsive candidate-table">
                                                <table className="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "80px" }}>Reason</th>
                                                            <th style={{ width: "80px" }}>Details</th>
                                                            <th style={{ width: "80px" }}>Attach 1</th>
                                                            <th style={{ width: "80px" }}>Attach 2</th>
                                                            <th style={{ width: "80px" }}>Attach 3</th>
                                                            <th style={{ width: "80px" }}>Attach 4</th>
                                                            <th style={{ width: "80px" }}>Comments</th>
                                                            <th style={{ width: "80px" }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {parentMainArray.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.reason}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.reason_details}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.doc_attach1 && item.doc_attach1 instanceof File ? (
                                                                        item.doc_attach1.type.startsWith("image/") ? (
                                                                            <img
                                                                                src={URL.createObjectURL(item.doc_attach1)}
                                                                                alt={item.doc_attach1.name}
                                                                                className="img-fluid"
                                                                                style={{ maxWidth: "100%", height: "auto" }}
                                                                            />
                                                                        ) : item.doc_attach1.type === "application/pdf" ? (
                                                                            <img
                                                                                src={pdf_img} // Replace `pdf_img` with the actual path to your PDF placeholder image
                                                                                width="200"
                                                                                alt="pdf-icon"
                                                                                className="img-fluid img-upload"
                                                                            />
                                                                        ) : (
                                                                            <span></span>
                                                                        )
                                                                    ) : (
                                                                        <span></span>
                                                                    )}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.doc_attach2 && item.doc_attach2 instanceof File ? (
                                                                        item.doc_attach2.type.startsWith("image/") ? (
                                                                            <img
                                                                                src={URL.createObjectURL(item.doc_attach2)}
                                                                                alt={item.doc_attach2.name}
                                                                                className="img-fluid"
                                                                                style={{ maxWidth: "100%", height: "auto" }}
                                                                            />
                                                                        ) : item.doc_attach2.type === "application/pdf" ? (
                                                                            <img
                                                                                src={pdf_img}
                                                                                width="200"
                                                                                alt="pdf-icon"
                                                                                className="img-fluid img-upload"
                                                                            />
                                                                        ) : (
                                                                            <span></span>
                                                                        )
                                                                    ) : (
                                                                        <span></span>
                                                                    )}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.doc_attach3 && item.doc_attach3 instanceof File ? (
                                                                        item.doc_attach3.type.startsWith("image/") ? (
                                                                            <img
                                                                                src={URL.createObjectURL(item.doc_attach3)}
                                                                                alt={item.doc_attach3.name}
                                                                                className="img-fluid"
                                                                                style={{ maxWidth: "100%", height: "auto" }}
                                                                            />
                                                                        ) : item.doc_attach3.type === "application/pdf" ? (
                                                                            <img
                                                                                src={pdf_img}
                                                                                width="200"
                                                                                alt="pdf-icon"
                                                                                className="img-fluid img-upload"
                                                                            />
                                                                        ) : (
                                                                            <span></span>
                                                                        )
                                                                    ) : (
                                                                        <span></span>
                                                                    )}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    {item.doc_attach4 && item.doc_attach4 instanceof File ? (
                                                                        item.doc_attach4.type.startsWith("image/") ? (
                                                                            <img
                                                                                src={URL.createObjectURL(item.doc_attach4)}
                                                                                alt={item.doc_attach4.name}
                                                                                className="img-fluid"
                                                                                style={{ maxWidth: "100%", height: "auto" }}
                                                                            />
                                                                        ) : item.doc_attach4.type === "application/pdf" ? (
                                                                            <img
                                                                                src={pdf_img}
                                                                                width="200"
                                                                                alt="pdf-icon"
                                                                                className="img-fluid img-upload"
                                                                            />
                                                                        ) : (
                                                                            <span></span>
                                                                        )
                                                                    ) : (
                                                                        <span></span>
                                                                    )}
                                                                </td>

                                                                <td style={{ width: "80px" }}>
                                                                    {item.notes}
                                                                </td>
                                                                <td style={{ width: "80px" }}>
                                                                    <FaWindowClose
                                                                        fontSize={20}
                                                                        onClick={() => handleRemoveItem(index)}

                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div> : ""}


                                            <div className="d-flex aling-items-center justify-content-end gap-2 mt-3">
                                                <button className="btn btn-btn1 btn-btn btn-sm" disabled={loading} onClick={saveNewRequirement}>
                                                    {loading ? (
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        "Submit"
                                                    )}
                                                </button>{" "}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {BlacklistReason && (
                        <BlacklistPopUp
                            onclose={() => setBlacklistReason(false)}
                            onSubmit={handleReasonData}
                        />
                    )}
                </div>
            </div>
        </>
    );
}

export default CandidateBlackListInfo;
